module.exports = "/_next/static/images/cell_3-ba29143f3b08a0221a301f39694e0d99.png";